import { render } from "./HeroiconsSolidMenu.vue?vue&type=template&id=76876b4f"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMenu.vue"]])

export default __exports__